// Add your custom JS here.

(function ($) {
    $(window).on('load resize', function () {
    });
    function checkHeight(ele) {
        var h = 0;
        $(ele).each(function () {
            if ($(this).height() > h) {
                h = $(this).height();
            }
        });
        $(ele).css('height', h + 'px');
    }

    function setFullHeight() {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);

        setTimeout(() => {
            const uberMega = document.querySelectorAll('.ubermenu-submenu-type-mega');
            if (uberMega) {
                const vw = window.innerWidth;
                const headerContainer = document.querySelector('.header .container').clientWidth + 24;
                uberMega.forEach(elem => {
                    elem.style.padding = `24px ${(vw - headerContainer) / 2}px`;
                });
            }
        }, 1000);

    }

    window.addEventListener('resize', setFullHeight);
    setFullHeight();

    $(document).ready(function () {

        $(window).on('scroll', function () {
            if ($(window).scrollTop() > 100) {
                $('.toTop').addClass('active');
            } else {
                $('.toTop').removeClass('active');
            }

            if ($(window).scrollTop() > 5) {
                $('.header').addClass('fixed');
            } else {
                $('.header').removeClass('fixed');
            }
        });

        $('.toTop').on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 'swing');
        });

        $('.menu-item-has-children').append('<button type="button" class="btnSub"><i class="far fa-angle-down"></i></button>');

        $(document).on('click', '.btnSub', function (e) {
            e.preventDefault();
            $(this).toggleClass('active').siblings('.subMenu').slideToggle(300);
        });

        $(document).on('click', '.openMenu', function (e) {
            e.preventDefault();
            $('body').toggleClass('activeMenu');
        });
        $(document).on('click', '.closeMenu', function (e) {
            e.preventDefault();
            $('body').removeClass('activeMenu');
        });

        $(document).on('click', '.toggleSea', function (e) {
            e.preventDefault();
            $('.header__fixed').removeClass('active');
            $('.header__search').toggleClass('active');
        });

        $(window).on('scroll', function () {
            if ($('.process .figureNumber').length) {
                $('.process .figureNumber').each(function () {
                    var $this = $(this);
                    var position = $this.offset().top;
                    var scrollPosition = $(window).scrollTop() + $(window).height();
                    // Chạy khi phần tử xuất hiện trong màn hình
                    if (position < scrollPosition) {
                        runCounter($this);
                    }
                });
            }

            if ($('.aboutBusiness__item').length) {
                $('.aboutBusiness__item').each(function () {
                    var $this = $(this);
                    var $number = $this.find('.number');
                    var position = $this.offset().top;
                    var scrollPosition = $(window).scrollTop() + $(window).height();
                    // Chạy khi phần tử xuất hiện trong màn hình
                    if (position < scrollPosition) {
                        runCounter($number);
                    }
                });
            }
        });



        if ($('.singleProd__images').length) {
            const prodThumbs = new Swiper(".singleProd__thumbs", {
                loop: true,
                spaceBetween: 8,
                slidesPerView: 5,
                watchSlidesProgress: true,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 3,
                        spaceBetween: 5
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 3,
                        spaceBetween: 5
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 4,
                        spaceBetween: 8
                    },
                    // when window width is >= 640px
                    991: {
                        slidesPerView: 5,
                        spaceBetween: 8,
                    }
                }
            });
            const prodImages = new Swiper(".singleProd__images", {
                loop: true,
                spaceBetween: 10,
                effect: "fade",
                fadeEffect: {
                    crossFade: true,
                },
                navigation: {
                    nextEl: ".singleProd__thumbsWrap .swiper-button-next",
                    prevEl: ".singleProd__thumbsWrap .swiper-button-prev",
                },
                pagination: false,
                thumbs: {
                    swiper: prodThumbs,
                },
            });
        }

        if($(".partner__slider").length) {
            const partner = new Swiper(".partner__slider", {
                loop: true,
                spaceBetween: 32,
                slidesPerView: 6,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                speed: 500,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 3,
                        spaceBetween: 5
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 3,
                        spaceBetween: 5
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 4,
                        spaceBetween: 16
                    },
                    // when window width is >= 640px
                    991: {
                        slidesPerView: 6,
                        spaceBetween: 32,
                    }
                }
            });
        }
        function runCounter($element) {
            if (!$element.hasClass("counted")) {
                var numberString = $element.html();
                var cleanedNumberString = numberString.replace(/\./g, '');
                var targetNumber = parseInt(cleanedNumberString, 10);

                if (!isNaN(targetNumber)) {
                    $element.addClass("counted");
                    $({ countNum: 0 }).animate({ countNum: targetNumber }, {
                        duration: 3000,
                        easing: "linear",
                        step: function () {
                            let currentNum = Math.floor(this.countNum);
                            let formattedNum;

                            // SỬA ĐỔI: Thêm số 0 đằng trước nếu số nhỏ hơn 10
                            if (currentNum < 10) {
                                formattedNum = '0' + currentNum;
                            } else {
                                // Giữ nguyên định dạng gốc cho các số lớn hơn hoặc bằng 10
                                formattedNum = currentNum.toLocaleString('de-DE', {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0
                                });
                            }
                            $element.text(formattedNum);
                        },
                        complete: function () {
                            let formattedTarget;

                            // SỬA ĐỔI: Đảm bảo số cuối cùng cũng được định dạng tương tự
                            if (targetNumber < 10) {
                                formattedTarget = '0' + targetNumber;
                            } else {
                                formattedTarget = targetNumber.toLocaleString('de-DE', {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0
                                });
                            }
                            $element.text(formattedTarget);
                        }
                    });
                } else {
                    console.error("Lỗi: Không thể chuyển đổi '" + numberString + "' thành số hợp lệ.");
                }
            }
        }

        setTimeout(function () {
            AOS.init({ disable: 'mobile', once: true });
        }, 500);

        if ($(['data-fancybox']).length) {
            $('data-fancybox').fancybox();
        }

        if ($('.prodContent__body').length) {
            const tableElem = $('.prodContent__body table');
            if (tableElem) {
                setTimeout(() => {
                    tableElem.each((idx, elem) => {
                        $(elem).wrap('<div class="tableWrap"></div>');
                    });
                }, 1000);
            }
        }

        setTimeout(() => {
            if ($('.aboutHistory__box .item__content').length) {
                let heightContent = 0;
                $('.aboutHistory__box .item__content').each(function () {
                    const newHeight = $(this).outerHeight();
                    if (heightContent < newHeight) {
                        heightContent = newHeight;
                    }
                });
                $('.aboutHistory__box .item__content').css('height', heightContent + 'px');
                $('.aboutHistory__box').css('padding-bottom', (heightContent + 10) + 'px');
            }
        }, 1000);

    });

    document.addEventListener('DOMContentLoaded', function () {
        const historyWrap = document.querySelector('.aboutHistory__wrap');
        const historyBox = document.querySelector('.aboutHistory__box');
        let isDragging = false;
        let startX;
        let scrollLeft;

        if (historyWrap && historyBox) {
            historyWrap.addEventListener('mousedown', (e) => {
                isDragging = true;
                startX = e.pageX - historyBox.offsetLeft;
                scrollLeft = historyWrap.scrollLeft;
                historyWrap.style.cursor = 'grabbing';
            });

            historyWrap.addEventListener('mouseleave', () => {
                isDragging = false;
                historyWrap.style.cursor = 'grab';
            });

            historyWrap.addEventListener('mouseup', () => {
                isDragging = false;
                historyWrap.style.cursor = 'grab';
            });

            historyWrap.addEventListener('mousemove', (e) => {
                if (!isDragging) return;
                e.preventDefault();
                const x = e.pageX - historyBox.offsetLeft;
                const walk = (x - startX) * 1; // Điều chỉnh hệ số này để thay đổi tốc độ kéo
                historyWrap.scrollLeft = scrollLeft - walk;
            });
        }
    });

    // Chờ toàn bộ trang và tài nguyên được tải xong
    window.addEventListener('load', () => {

        // Tìm tất cả các phần tử có class 'js-marquee-container' trên trang
        // Bạn cần thêm class này vào các div chứa marquee của mình trong HTML
        const marqueeContainers = document.querySelectorAll('.myMarquee');

        // Lặp qua từng phần tử tìm được và thiết lập marquee cho mỗi phần tử
        marqueeContainers.forEach(marqueeContainer => {
            // Gọi hàm setupMarquee cho từng container
            setupMarquee(marqueeContainer);
        });

    });

    // Hàm để thiết lập và chạy animation cho một marquee cụ thể
    function setupMarquee(marqueeContainer) {
        // Kiểm tra xem container có tồn tại không
        if (!marqueeContainer) {
            console.error("Marquee container element not provided.");
            return;
        }

        const marqueeWrapper = marqueeContainer.querySelector('.marqueeContainer');
        if (!marqueeWrapper) {
            console.error("Marquee wrapper '.marqueeContainer' not found inside the provided container.", marqueeContainer);
            return;
        }

        const originalItems = Array.from(marqueeWrapper.children);
        if (originalItems.length === 0) {
            console.warn("Marquee wrapper has no child elements inside container.", marqueeContainer);
            return; // Không có phần tử để tạo hiệu ứng
        }

        // --- Cấu hình (Có thể lấy từ data- attribute nếu muốn tùy chỉnh cho từng marquee) ---
        // Đọc cấu hình từ data- attribute trên container (nếu có) hoặc dùng giá trị mặc định
        const speed = parseFloat(marqueeContainer.dataset.speed) || 80; // pixels per second
        const direction = parseInt(marqueeContainer.dataset.direction) || -1; // -1: Left, 1: Right
        const pauseOnHover = marqueeContainer.dataset.pauseOnHover !== 'false'; // Mặc định là true trừ khi là 'false'

        // --- Nhân bản các phần tử ---
        // Xóa các phần tử nhân bản cũ nếu hàm được gọi lại (ví dụ: trong quá trình phát triển)
        // Giữ lại số lượng phần tử ban đầu
        while (marqueeWrapper.children.length > originalItems.length) {
            marqueeWrapper.removeChild(marqueeWrapper.children[originalItems.length]);
        }

        // Nhân bản các phần tử ban đầu
        originalItems.forEach(item => {
            const clone = item.cloneNode(true);
            // Tùy chọn: Thêm class hoặc attribute để nhận diện bản sao
            // clone.setAttribute('data-clone', 'true');
            marqueeWrapper.appendChild(clone);
        });

        // --- Tính toán chiều rộng và thời lượng dựa trên chiều rộng thực tế sau khi render ---
        // Sử dụng requestAnimationFrame để đảm bảo các style và layout đã được tính toán xong
        requestAnimationFrame(() => {
            // Đo tổng chiều rộng của wrapper chứa cả phần tử gốc + bản sao
            const totalWidth = marqueeWrapper.scrollWidth;

            // Chiều rộng cần thiết cho một chu kỳ chạy là chiều rộng của các phần tử gốc
            // Vì đã nhân đôi, chiều rộng của phần tử gốc là một nửa totalWidth
            const resetWidth = totalWidth / 2; // Đây là chiều rộng của nội dung gốc (trước khi nhân đôi)

            // Kiểm tra xem nội dung có đủ rộng để cuộn hay không
            if (resetWidth <= 0 || resetWidth <= marqueeContainer.offsetWidth) {
                // console.warn("Marquee content is not wide enough to scroll or width calculation failed for container.", marqueeContainer);
                // Xóa các bản sao nếu không cuộn
                while (marqueeWrapper.children.length > originalItems.length) {
                    marqueeWrapper.removeChild(marqueeWrapper.children[originalItems.length]);
                }
                // Tùy chọn: Thêm style để nội dung hiển thị bình thường nếu không cuộn
                marqueeWrapper.style.animation = 'none';
                marqueeWrapper.style.transform = 'translateX(0)';
                return; // Không có gì để tạo hiệu ứng
            }

            // Tính toán thời lượng animation (đơn vị miliseconds)
            // Thời lượng = Quãng đường / Tốc độ * 1000
            const duration = (speed > 0) ? (resetWidth / speed) * 1000 : 0;

            // Hủy bỏ animation cũ nếu có (trường hợp hàm được gọi lại)
            if (marqueeWrapper.animation) {
                marqueeWrapper.animation.cancel();
            }

            // --- Tạo Animation sử dụng WAAPI ---
            if (duration > 0) {
                // Keyframes cho animation cuộn lặp vô hạn
                // Cuộn từ 0 đến -resetWidth (đối với direction -1)
                // Cuộn từ 0 đến +resetWidth (đối với direction 1 - cần kiểm tra lại logic này)
                // Để đảm bảo lặp mượt, điểm bắt đầu và kết thúc cần cách nhau đúng bằng resetWidth
                // Nếu cuộn sang trái (-1): Bắt đầu 0px, Kết thúc -resetWidth px
                // Nếu cuộn sang phải (1): Bắt đầu -resetWidth px, Kết thúc 0px HOẶC Bắt đầu 0px, Kết thúc +resetWidth px (cần điều chỉnh CSS overflow/position)
                // Với setup hiện tại, cuộn sang trái là phổ biến và dễ setup nhất với translateX(0) -> translateX(-resetWidth)
                let keyframes;
                if (direction === -1) { // Cuộn sang trái
                    keyframes = [
                        { transform: 'translateX(0)' },
                        { transform: 'translateX(' + (-resetWidth) + 'px)' }
                    ];
                } else { // Cuộn sang phải (cần điều chỉnh lại một chút logic hoặc CSS để nó mượt)
                    // Cách đơn giản nhất cho cuộn phải với clone là cuộn từ -resetWidth -> 0
                    keyframes = [
                        { transform: 'translateX(' + (-resetWidth) + 'px)' },
                        { transform: 'translateX(0)' }
                    ];
                    // Điều chỉnh tốc độ nếu cần thiết cho cuộn phải để cảm giác tương tự
                    // Hoặc điều chỉnh điểm bắt đầu/kết thúc keyframes và vị trí ban đầu của wrapper
                }


                const animation = marqueeWrapper.animate(
                    keyframes,
                    {
                        duration: duration,
                        iterations: Infinity, // Lặp vô hạn
                        easing: 'linear' // Tốc độ đều
                    }
                );

                // Lưu đối tượng animation vào phần tử wrapper để dễ truy cập
                marqueeWrapper.animation = animation;

                // --- Xử lý Dừng/Chạy khi di chuột qua ---
                if (pauseOnHover) {
                    // Sử dụng function expressions để dễ dàng gỡ bỏ listener sau này nếu cần
                    const pauseAnimation = () => marqueeWrapper.animation?.pause();
                    const playAnimation = () => marqueeWrapper.animation?.play();

                    // Thêm listener vào phần tử container (bao ngoài)
                    marqueeContainer.addEventListener('mouseenter', pauseAnimation);
                    marqueeContainer.addEventListener('mouseleave', playAnimation);

                    // Tùy chọn: Lưu lại listener để có thể gỡ bỏ trong tương lai (ví dụ khi xóa marquee)
                    marqueeContainer.animationListeners = { pauseAnimation, playAnimation };
                }
            } else {
                // Nếu thời lượng bằng 0 (tốc độ bằng 0), đảm bảo xóa bản sao
                while (marqueeWrapper.children.length > originalItems.length) {
                    marqueeWrapper.removeChild(marqueeWrapper.children[originalItems.length]);
                }
                marqueeWrapper.style.animation = 'none'; // Đảm bảo không có animation CSS cũ
                marqueeWrapper.style.transform = 'translateX(0)'; // Đảm bảo về vị trí ban đầu
            }
        }); // Kết thúc requestAnimationFrame

    }

})(jQuery)

// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function (event) {

    console.log("DOM loaded");

    //wait until images, links, fonts, stylesheets, and js is loaded
    window.addEventListener("load", function (e) {

        const frame1 = this.document.querySelector('.homeSolution__animateHori .frame1');
        const frame3 = this.document.querySelector('.homeSolution__animateHori .frame3');
        const frame1Shadow = this.document.querySelector('.homeSolution__animateHori .frame1Shadow');

        const framever1 = this.document.querySelector('.homeSolution__animateVer .frameVer1');
        const framever2 = this.document.querySelector('.homeSolution__animateVer .frameVer2');
        const framever3 = this.document.querySelector('.homeSolution__animateVer .frameVer3');
        const framever4 = this.document.querySelector('.homeSolution__animateVer .frameVer4');
        const framever5 = this.document.querySelector('.homeSolution__animateVer .frameVer5');
        const framever6 = this.document.querySelector('.homeSolution__animateVer .frameVer6');
        const frameverCur = this.document.querySelector('.homeSolution__animateVer .frameVerCur');
        if (frame1) {
            const tl = gsap.timeline({
                repeat: -1,
                repeatDelay: .5
                // yoyo: true
            });
            tl.set(frame1, {
                transformOrigin: "left center",
            }).to(frame1, {
                rotationY: 55,
                x: -25,
                duration: 4,
                ease: 'power2.out'
            }).to(frame1, {
                rotation: 20,
                y: -40,
                duration: 4,
                // ease: 'circ.out'
            }).to(frame1, {
                rotation: 0,
                rotationY: 0,
                x: 0,
                y: 0,
                duration: 4,
            })
        }
        if (frame1Shadow) {
            const tl = gsap.timeline({
                repeat: -1,
                repeatDelay: .5
                // yoyo: true
            });
            tl.set(frame1Shadow, {
                transformOrigin: "left center",
            }).to(frame1Shadow, {
                rotationY: 55,
                x: 0,
                duration: 4,
                ease: 'power2.out'
            }).to(frame1Shadow, {
                rotation: 10,
                x: 20,
                y: -40,
                scaleX: 0.8,
                duration: 4,
                // ease: 'circ.out'
            }).to(frame1Shadow, {
                rotation: 0,
                rotationY: 0,
                scaleX: 1,
                x: 0,
                y: 0,
                duration: 4,
            })
        }
        if (frame3) {
            const tl = gsap.timeline({
                repeat: -1,
                repeatDelay: .5
                // yoyo: true
            });
            tl.set(frame3, {
                transformOrigin: "left center",
            }).to(frame3, {
                scaleX: 1.4,
                duration: 4,
                ease: 'power2.out'
            }).to(frame3, {
                scaleX: 1,
                duration: 4,
                delay: 4
            })
        }
        
        if (framever1) {
            const tl = gsap.timeline({
                repeat: -1,
                repeatDelay: .5
                // yoyo: true
            });
            tl.set(framever1, {
                transformOrigin: "center center",
            }).to(framever1, {
                y: 106,
                duration: 4,
                ease: 'power2.out'
            }).to(framever1, {
                y: 0,
                duration: 4,
            })
        }
        if (framever4) {
            const tl = gsap.timeline({
                repeat: -1,
                repeatDelay: .5
                // yoyo: true
            });
            tl.set(framever4, {
                transformOrigin: "center center",
            }).to(framever4, {
                y: -122,
                opacity: 0.5,
                duration: 4,
                ease: 'power2.out'
            }).to(framever4, {
                y: 0,
                opacity: 1,
                duration: 4,
            })
        }
        if (framever5) {
            const tl = gsap.timeline({
                repeat: -1,
                repeatDelay: .5
                // yoyo: true
            });
            tl.set(framever5, {
                transformOrigin: "right center",
            }).to(framever5, {
                y: -80,
                opacity: 1,
                duration: 4,
                ease: 'power2.out'
            }).to(framever5, {
                y: 0,
                opacity: 0,
                duration: 4,
            })
        }
        if (framever6) {
            const tl = gsap.timeline({
                repeat: -1,
                repeatDelay: .5
                // yoyo: true
            });
            tl.set(framever6, {
                transformOrigin: "right center",
            }).to(framever6, {
                y: -80,
                opacity: 1,
                duration: 4,
                ease: 'power2.out'
            }).to(framever6, {
                y: 0,
                opacity: 0,
                duration: 4,
            })
        }
        if (framever2) {
            const tl = gsap.timeline({
                repeat: -1,
                repeatDelay: .5
                // yoyo: true
            });
            tl.set(framever2, {
                transformOrigin: "right center",
            }).to(framever2, {
                y: 85,
                opacity: 1,
                scaleX: 0.9,
                duration: 4,
                ease: 'power2.out'
            }).to(framever2, {
                y: 0,
                opacity: 0,
                scaleX: 1,
                duration: 4,
            })
        }
        if (framever3) {
            const tl = gsap.timeline({
                repeat: -1,
                repeatDelay: .5
                // yoyo: true
            });
            tl.set(framever3, {
                transformOrigin: "right center",
            }).to(framever3, {
                y: 100,
                opacity: 1,
                scale: 0.85,
                duration: 4,
                ease: 'power2.out'
            }).to(framever3, {
                y: 0,
                opacity: 0,
                scale: 1,
                duration: 4,
            })
        }

        console.log("window loaded");
    }, false);

});
